import React from 'react'
import Hero from '../components/Hero'
import Services from '../components/Services'

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
    </>
  )
}

export default HomePage